import { BannerRepository } from '../../../domain/repositories/banner.repository';
import { BannerSettingsEntity } from '../../../domain/entities/banner-settings.entity';

export class SaveBannerSettingsUseCase {
  constructor(private readonly bannerRepository: BannerRepository) {}

  public async execute(settings: BannerSettingsEntity): Promise<BannerSettingsEntity> {
    if (this.bannerRepository.saveSettings) {
      return this.bannerRepository.saveSettings(settings);
    }
    return settings;
  }
}
